import Swiper from "swiper";
import { Autoplay, Controller, EffectFade } from "swiper/modules";
import { CountUp } from "countup.js";
export const vision = () => ({
  initVisionFadeText: () => {

    let isAutoplayStarted = false;
    const textSlider = document.querySelector('.oval-image__right .swiper') as HTMLElement;
    const textCounterSlider = document.querySelector('.oval-image__left .swiper') as HTMLElement;
    const counterTextElements = document.querySelectorAll('.oval-image__text-display') as NodeListOf<HTMLElement>;
 
    const textSliderInstance = new Swiper(textSlider, {
        slidesPerView: 1,
        allowTouchMove: false,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        autoplay: false,

        modules: [EffectFade],
      });

      const counterSliderInstance = new Swiper(textCounterSlider, {
        slidesPerView: 1,
        allowTouchMove: false,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        autoplay: false,

        modules: [EffectFade, Autoplay, Controller],
      });

      counterSliderInstance.controller.control = textSliderInstance;


      counterTextElements.forEach((el) => {
      new CountUp(
        el,
        Number(el.dataset.percentage),
        {
          duration: 2,
          enableScrollSpy: true,
          scrollSpyDelay: 200,
          scrollSpyOnce: true,
          suffix: "%",
          onCompleteCallback: () => {
            if(!isAutoplayStarted){
              counterSliderInstance.params.autoplay = {
                delay: 5000,
                disableOnInteraction: false,
              };
              counterSliderInstance.autoplay.start();
              isAutoplayStarted = true;
            }
          },
        },
      );
    });
  },
});

